import * as React from "react"

export const ModalContext = React.createContext({
    currentCard: { url: '', alt: '' },
    isVisbleModal: false,
    toggleModal: () => { },
})